/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, InputSelect, Label, Modal, CustomLoading, Input, InputCheckbox, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListEquipamentHasPartCommands = () => {
    const { t } = useTranslation();

    document.title = "Ligações de parts de comandos e equipamentos";
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [parts, setParts] = useState([]);
    const [equipments, setEquipments] = useState([]);

    const partCommandField = useRef();
    const equipamentField = useRef();
    const custom_nameField = useRef();
    const keyField = useRef();
    const nameField = useRef();

    const partCommandValue = useRef();
    const equipamentValue = useRef();
    const custom_nameValue = useRef();
    const keyValue = useRef();
    const nameValue = useRef();
    const isActiveValue = useRef(false);

    useEffect(() => {
        async function getAllPartCommands(){
            let currentList = await Services.current.getEquipmentHasPartsCommands();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        async function getPartCommand(){
            let currentItem = await Services.current.getEquipments();
            setParts(currentItem);
        }

        async function getEquipments(){
            let currentItem = await Services.current.getEquipments();
            setEquipments(currentItem);
        }

        getAllPartCommands();
        getPartCommand();
        getEquipments();
    }, [])

    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(partCommandValue.current) && isValidField(equipamentValue.current) && 
            isValidField(custom_nameValue.current)){

            let form = new FormData();
            if(partCommandValue.current){form.append('part_command', partCommandValue.current)}
            if(equipamentValue.current){form.append('id_equipment', equipamentValue.current)}
            if(custom_nameValue.current){form.append('custom_name', custom_nameValue.current)}
            if(keyValue.current){form.append('key', keyValue.current)}
            if(nameValue.current){form.append('name', nameValue.current)}

            form.append('active', isActiveValue.current ? 1 : 0)    
            await Services.current.SaveEquipmentHasPartsCommand(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    Ligações de parts de comandos e equipamentos
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + (partCommands?.nbiot?.length + partCommands?.poco?.length) + " Ligações" }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'white-red'} icon={''} text={"+ Criar nova ligação"}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>Nome</TitleText>
                        <TitleText>Equipamento</TitleText>
                        <TitleText>Comando</TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        <>
                            {partCommands?.nbiot?.map((item, index)=>(
                                <LineList key={index} href={`/EquipmentHasPartsCommands/${item.id}`}>
                                    <ListText>{item.name}</ListText>
                                    <ListText>{item.nbiot_id}</ListText>
                                    <ListText>{item.part_command_name}</ListText>
                                </LineList>
                            ))}
                            {partCommands?.poco?.map((item, index)=>(
                                <LineList key={index} href={`/EquipmentHasPartsCommands/${item.id}`}>
                                    <ListText>{item.custom_name}</ListText>
                                    <ListText>{item.poco_id}</ListText>
                                    <ListText>{item.part_command_name}</ListText>
                                </LineList>
                            ))}
                        </>
                    }
                </ContainerList>
            </Container>
            
            <Modal title={t("administrative.partCommands.add")} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={"part Command"} aling="flex-start"/>
                        <InputSelect
                            key={'part_command'}
                            name={'part_command'}
                            id={'part_command'}
                            placeholder={"Part Command"}
                            invalidMessage = {"Part Command inválido!"}
                            options={parts}
                            innerRef={partCommandField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => partCommandValue.current = value}>
                        </InputSelect> 

                        <Label text={"Nome Comando"} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='CommandName' 
                            name='CommandName' 
                            type="text" 
                            placeholder= {"Nome"}
                            innerRef={custom_nameField}
                            invalidMessage = {"Nome inválido!"}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => custom_nameValue.current = text}> 
                        </Input>

                        <Label text={"Key"} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='key' 
                            name='key' 
                            type="text" 
                            placeholder= {"Key"}
                            innerRef={keyField}
                            invalidMessage = {"Key inválido!"}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => keyValue.current = text}> 
                        </Input>

                        <Label text={"Nome"} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='name' 
                            name='name' 
                            type="text" 
                            placeholder= {"Nome"}
                            innerRef={nameField}
                            invalidMessage = {"Nome inválido!"}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => nameValue.current = text}> 
                        </Input>

                    </ContainerColumn>

                    <ContainerColumn>
                        <Label text={"Equipamento"} aling="flex-start"/>
                        <InputSelect
                            key={'equipment'}
                            name={'equipment'}
                            id={'equipment'}
                            placeholder={"Equipamento"}
                            invalidMessage = {"Equipamento inválida!"}
                            options={equipments}
                            innerRef={equipamentField}
                            validationFunction = {(value) => isValidField(value)}
                            onchange={(value) => equipamentValue.current = value}>
                        </InputSelect>

                        <InputCheckbox text={t("inputs.isActive.label")} onChange={(value)=> {isActiveValue.current = value; return true}}/>
                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListEquipamentHasPartCommands;